module.exports = [{
      plugin: require('../../../node_modules/.pnpm/gatsby-plugin-layout@4.14.0_gatsby@5.14.5_babel-eslint@10.1.0_eslint@7.32.0__eslint-import-re_llnu7tisq7zaz7xuz6jmc7jxzy/node_modules/gatsby-plugin-layout/gatsby-browser.js'),
      options: {"plugins":[],"component":"/opt/atlassian/pipelines/agent/build/packages/ui/src/wrapper.tsx"},
    },{
      plugin: require('../../../node_modules/.pnpm/gatsby-plugin-manifest@5.14.0_gatsby@5.14.5_babel-eslint@10.1.0_eslint@7.32.0__eslint-import-_jyjrufsbbyczjbehveytav3fue/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"icon":"src/images/icon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"e66f65e59cd57ae85e3a43c797136ab8"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../../../node_modules/.pnpm/gatsby@5.14.5_babel-eslint@10.1.0_eslint@7.32.0__eslint-import-resolver-typescript@2.7.1_esli_s33mcic47hnbbdy7efacla2kyi/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
